module.exports = __webpack_public_path__ + "media/components/src/assets/images/image_text2/16-af5bd35d6b034ff8a9860e2d8ea55014.jpg";